import React, {useEffect, useState} from 'react'
import {connect} from "react-redux";
import Auth from '../components/auth'
import {Layout, Row, Button, Col,Empty, Tag, Space,Avatar, Input} from 'antd';

const {TextArea} = Input;
import '../home.css'
import {UserOutlined, HomeOutlined, AuditOutlined} from '@ant-design/icons';
import EmoticonDemo from './editor'
import BraftEditor from "braft-editor";

const {Header, Footer, Content, Sider} = Layout;
// <!--<Space style={{width:'100vh'}}>
//     <TextArea rows={2} placeholder="输入内容" maxLength={100} style={{width:'245px',border: "1px solid #dfdfdf"}}></TextArea>
//     <Button type="primary" size={"large"} style={{width:"100px",height:"54px"}}>发送</Button>
// </Space>-->

const Home = ({user}) => {

    const [status, setStatus] = useState(false)
    const [room, setRoom] = useState({})
    const [context, setContext] = useState({
        editorState: BraftEditor.createEditorState(''),
        outputHTML: ''
    })

    const [remote, setRemote] = useState([])

    useEffect(() => {
        if (!status && user.isAgree && user.name !== "" && user.room !== "" && user.uid !== "") {
            async function check(strName, intRoom) {
                var result = await fetch(API_URL + '/check',{
                    //mode:'cors',
                    method:'POST',
                    body:JSON.stringify({
                        name:strName,
                        room:intRoom,
                    }),
                    headers:{
                        'Content-type': 'application/json; charset=UTF-8',
                    },
                })
                return  result.json()
            }
            check(user.name, parseInt(user.room)).then(data=>{
                if (data.code == 200) {
                    console.log(user)
                    if (window.shreadespace !== undefined) {
                        let room = new window.shreadespace.Room({
                            "userId": user.uid,
                            "userName": user.name,
                            "roomName": user.room,
                            "wsUrl": WSS_URL,
                            "audioMuted": window.shreadespace.AudioMuted.OPEN,
                            "videoQuality": window.shreadespace.VideoQuality.VGA,
                            "share": shreadespace.Share.OPEN
                        });
                        room.OnRemoteObject = function (v) {
                            document.getElementById("remote").appendChild(v);
                        }

                        room.OnChatMessages = function (data) {
                            console.log("message",data);
                            const ele = document.createElement("div");
                            ele.setAttribute("class","chatItem");
                            ele.innerHTML = "<div class=\"list-nickname\">" + data.name +": </div>\n" +
                                "                  <div class=\"list-brief\">"+data.context+"</div>";
                            document.getElementById("chat").appendChild(ele)
                            document.getElementById("chat").scrollTop = document.getElementById("chat").scrollHeight;
                        }

                        // room.OnReport = function (v) {
                        //     console.log("report", v);
                        // }

                        room.OnError = function (code, message) {
                            console.log("error", code, message);
                        }

                        room.OnShareMessage = function (data) {
                            console.log("share message",data);
                            const ele = document.createElement("div");
                            ele.setAttribute("class","chatItem");
                            ele.innerHTML = "<div class=\"list-nickname\">" + data.header.name +": </div>\n" +
                                "<div class=\"list-brief\"><b>分享屏幕</b></div>";
                            document.getElementById("chat").appendChild(ele)
                            document.getElementById("chat").scrollTop = document.getElementById("chat").scrollHeight;
                            sourceState(true)
                        }

                        room.OnCreateUserElement = function (info, stream) {
                            setRemote(()=>{

                                let ele = remote.find(o=>o.stream === stream["stream"]);
                                if(ele !== undefined) {
                                    //ele["track"].addTrack(stream["track"]);
                                    const video = document.getElementById(stream["stream"]);
                                    console.log("create ele set track");
                                    video.srcObject = stream["track"];
                                }else{
                                    console.log("create ele undefined id");
                                    info["stream"] = stream["stream"];
                                    remote.push(info);
                                }
                                return [...remote]
                            })
                        }
                        setRoom(room)
                    }
                    setStatus(true)




                }else{
                    alert('账户已经过期，请微信联系管理员')
                }
            })


        }

    }, [])
    const contextChange = (e) => {
        console.log("context change ",e,e.toHTML())
        setContext({
            editorState:e,
            outputHTML: e.toHTML()
        })
    };

    const submitMessage = (e) => {
        console.log("submit", room);
        setContext({
            editorState: BraftEditor.createEditorState(''),
            outputHTML: ''
        })
        room.chatSendMessage(context.outputHTML);
        const ele = document.createElement("div");
        ele.setAttribute("class","chatItem");
        ele.innerHTML = "<div class=\"list-nickname\">" + room.userName +": </div>\n" +
            "                  <div class=\"list-brief\">"+context.outputHTML+"</div>";
        document.getElementById("chat").appendChild(ele)
        document.getElementById("chat").scrollTop = document.getElementById("chat").scrollHeight;
    };

    const submitShare = (e) => {
        shareState(true)
        sourceState(true)
        room.ShareScreen()
    }

    const closeShare = (e) => {
        shareState(false)
        room.ShareScreenClose()
    }
    const imgHandler = (e,kind, uid) => {
        console.log("img handler", e.currentTarget.getAttribute("data-open"),kind, uid);
        let open = e.currentTarget.getAttribute("data-open");
        if (kind== "audio") {
            if (open == "yes") {
                e.currentTarget.setAttribute("data-open","no");
                e.currentTarget.setAttribute("src", "volume_off_FILL0_wght400_GRAD0_opsz48.svg");
                room.closeAudio(uid);
                return;
            }else{
                e.currentTarget.setAttribute("data-open","yes");
                e.currentTarget.setAttribute("src", "volume_up_FILL0_wght400_GRAD0_opsz48.svg");
                room.openAudio(uid);
                return;
            }
        }
        if (kind == "video") {
            if (open == "yes" && kind== "video") {
                e.currentTarget.setAttribute("data-open","no");
                e.currentTarget.setAttribute("src", "videocam_off_FILL0_wght400_GRAD0_opsz48.svg");
                room.closeVideo(uid);
                return;
            }else{
                e.currentTarget.setAttribute("data-open","yes");
                e.currentTarget.setAttribute("src", "videocam_FILL0_wght400_GRAD0_opsz48.svg");
                room.openVideo(uid);
                return;
            }
        }
    }

    const [share, shareState] = useState(false)
    const [source, sourceState] = useState(false)
    return (
        <>
            <Row>
                <Col flex="auto" style={{border:"1px solid #d9d9df"}}>
                    <Row id="remote" type="flex" justify="center" align="middle">
                        <div>
                            <video id="localVideo"  autoPlay loop muted playsInline></video>
                            <span>{user.name}</span>
                            <img  data-open={'yes'}  onClick={(e)=>imgHandler(e,"audio", room.userId)} className={"audio"} src={"volume_up_FILL0_wght400_GRAD0_opsz48.svg"} />
                            <img  data-open={'yes'}  onClick={(e)=>imgHandler(e,"video", room.userId)} className={"video"} src={"videocam_FILL0_wght400_GRAD0_opsz48.svg"} />
                        </div>
                        {
                            remote.map((item, index) =>{
                                console.log("item", item);
                                return (
                                    <div key={index} id={item.uid}>
                                        <video id={item.stream}  autoPlay loop playsInline></video>
                                        <span>{item.name}</span>
                                        <img data-open={'yes'} onClick={(e) => imgHandler(e,"audio", item.uid)} className={"audio"} src={"volume_up_FILL0_wght400_GRAD0_opsz48.svg"}  />
                                        <img data-open={'yes'} onClick={(e)=>imgHandler(e,"video", item.uid)} className={"video"} src={"videocam_FILL0_wght400_GRAD0_opsz48.svg"} />
                                    </div>
                                )
                            })

                        }
                    </Row>
                    <Row style={{borderTop:"1px solid #d9d9d9"}}>
                        <div className="shareDiv">
                            <div style={{padding:"8px 0px"}}>
                                <Space>
                                    {!share ? <Button onClick={submitShare}>分享屏幕</Button> : <Button onClick={closeShare}>关闭分享</Button>}
                                </Space>
                            </div>
                            <div style={{textAlign:"center"}}>
                                {!source ? <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} /> : ''}
                                <video id="shareVideo" autoPlay loop muted playsInline></video>
                            </div>
                        </div>
                    </Row>
                </Col>
                <Col flex="none" style={{width:360}}>
                    <div style={{height:'100vh',paddingTop:"50px", paddingBottom:"93px",position:"relative"}}>
                        <div style={{height:'45px',position:"absolute",top:0,left:0,width:360,paddingTop:'15px',textAlign:'center'}}>
                            {user.name},欢迎来到<b>{user.room}</b>的房间!
                        </div>
                        <div id="chat" style={{height:'100%',overflow:'auto',borderTop:"1px solid #d9d9d9"}}>
                        </div>
                        <div style={{bottom:0,position:"absolute"}}>
                            <Space  align="end">
                                <EmoticonDemo change={contextChange} vv={context} cc={submitMessage} />
                                <Button id="chatBtn" onClick={submitMessage} type="primary" size={"large"} style={{width:"90px",height:"92px"}}>发送</Button>
                            </Space>
                        </div>
                    </div>
                </Col>
            </Row>
        </>
    )
}

const mapStateToProps = store => ({
    user: store.user
})

export default connect(mapStateToProps)(Auth(Home))